import Link from "next/link";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";

interface CategoryCardProps {
  title: string;
  image: string;
  slug: string;
}

const CategoryCard = ({ title, image, slug }: CategoryCardProps) => (
  <Link href={`/urunler/${slug}`}>
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <CardMedia
        component="img"
        height="260"
        image={image}
        alt={title}
        sx={{
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "scale(1.02)",
          },
        }}
      />
      <CardContent>
        <Typography
          variant="h6"
          fontWeight={700}
          align="center"
          color="#582308"
        >
          {title}
        </Typography>
      </CardContent>
    </Card>
  </Link>
);

export default CategoryCard;
